import { createNamespacer, createReducer } from "../utils/reducers";
/** Session reducer: manages auth status and user details. */

const initialState = {
  isLoggedIn: false,
  user: null,
  tenantDetails: null,
  userDetails: null,
};

const namespacer = createNamespacer("SESSION");

const handlers = {
  [namespacer("SET_IS_LOGGED_IN")]: (state: any, action: any) => {
    return {
      ...state,
      isLoggedIn: action.payload.value,
    };
  },
};

const reducer = createReducer(initialState, handlers, ["SESSION"]);

export default reducer;
